export const GET_PAYMENT_INFORMATION_ATTEMPT = 'GET_PAYMENT_INFORMATION_ATTEMPT';
export const GET_PAYMENT_INFORMATION_SUCCESS = 'GET_PAYMENT_INFORMATION_SUCCESS';
export const GET_PAYMENT_INFORMATION_FAILURE = 'GET_PAYMENT_INFORMATION_FAILURE';
export const CREATE_PAYMENT_INFORMATION_UPDATE_DELEGATE_ATTEMPT = 'CREATE_BILLING_INFORMATION_UPDATE_DELEGATE_ATTEMPT';
export const CREATE_PAYMENT_INFORMATION_UPDATE_DELEGATE_SUCCESS = 'CREATE_BILLING_INFORMATION_UPDATE_DELEGATE_SUCCESS';
export const CREATE_BILLING_INFORMATION_UPDATE_DELEGATE_FAILURE = 'CREATE_BILLING_INFORMATION_UPDATE_DELEGATE_FAILURE';
export const CLEAR_BILLING_INFORMATION_STATE = 'CLEAR_BILLING_INFORMATION_STATE';
